import { fetchGetDeReferralsProfile } from '@iwoca/lapi-client/edge_de';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../iwQueryClient/useStateKey';

export const useGetDeReferralsProfile = () => {
    const stateKey = useStateKey();
    return useQuery({
        suspense: true,
        queryKey: ['deReferralsProfile', stateKey],
        queryFn: () => fetchGetDeReferralsProfile({ stateKey }),
        select: (data) => data.data
    });
};
